import { render, staticRenderFns } from "./RenderView2d.vue?vue&type=template&id=7067146b"
import script from "./RenderView2d.vue?vue&type=script&lang=js"
export * from "./RenderView2d.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports